export default "/images/6dc8ad32abfc851c8c52403b6102e212.avif";